<template>
    <span :class="badgeClass">
        <slot>{{ label }}</slot>
    </span>
</template>
  
<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: "default", // success, warning, error, info
    },
    outline: {
      type: Boolean,
      default: false, // Si es true, aplica el estilo outline
    },
  },
  computed: {
    badgeClass() {
      return [
        `badge`,
        this.outline ? `badge-outline-${this.type}` : `badge-${this.type}`
      ];
    },
  },
};
</script>

<style scoped>
.badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
}

/* Estilos sólidos */
.badge-default {
  background-color: #ccc;
  color: #333;
}
.badge-success {
  background-color: #28a745;
  color: #fff;
}
.badge-warning {
  background-color: #ffc107;
  color: #333;
}
.badge-error {
  background-color: #dc3545;
  color: #fff;
}
.badge-info {
  background-color: #17a2b8;
  color: #fff;
}

/* Estilos Outline */
.badge-outline-default {
  background-color: transparent;
  border: 1px solid #ccc;
  color: #333;
}
.badge-outline-success {
  background-color: transparent;
  border: 1px solid #28a745;
  color: #28a745;
}
.badge-outline-warning {
  background-color: transparent;
  border: 1px solid #ffc107;
  color: #ffc107;
}
.badge-outline-error {
  background-color: transparent;
  border: 1px solid #dc3545;
  color: #dc3545;
}
.badge-outline-info {
  background-color: transparent;
  border: 1px solid #17a2b8;
  color: #17a2b8;
}
</style>